export default __webpack_public_path__ + "static/media/tete60.297a12f8.png";